import {useState} from 'react'

import {Popover} from '@mantine/core'

import DatePickerComponent from '../DateInput/DatePickerComponent'

const DropDownDate = ({
  children,
  onChange,
  value,
  top = 5,
  isInTable,
  allowSingleDate = false
}) => {
  const [opened, setOpened] = useState(false)
  const [currentValue, setCurrentValue] = useState(value)

  const handleChangeOpened = value => {
    setCurrentValue(undefined)
    setOpened(value)
  }

  const handleChange = dateRange => {
    setCurrentValue(dateRange)
    if (dateRange[0] && dateRange[1]) {
      onChange(dateRange)
      setOpened(false)
    }
  }

  const handleClose = () => {
    if (!value || !(value[0] && value[1])) {
      onChange([null, null])
    }
  }

  return (
    <Popover
      opened={opened}
      onChange={handleChangeOpened}
      onClose={handleClose}
      position={isInTable ? 'bottom-end' : 'bottom-start'}
      offset={top}
      width="auto"
      withinPortal={true}>
      <Popover.Target>
        <div onClick={() => setOpened(prev => !prev)}>{children}</div>
      </Popover.Target>

      <Popover.Dropdown style={{padding: 0, zIndex: 99999, marginTop: '1px'}}>
        <div style={{padding: 5, minWidth: 200}}>
          <DatePickerComponent
            type="range"
            value={currentValue}
            allowSingleDate={allowSingleDate}
            onChange={handleChange}
          />
        </div>
      </Popover.Dropdown>
    </Popover>
  )
}

export default DropDownDate
